export enum DataEnum {
  MASTER = 'master',
  SKILLS = 'skills',
  PROJECTS = 'projects'
}